import { Order, VisibleColumnSpec } from "@/types";

export const DEFAULT_ORDER_COLUMNS: VisibleColumnSpec<
  Order,
  "actions" | "icon" | "tradeId" | "product" | "contract" | "lastPrice"
>[] = [
  "tradeId",
  "created",
  "contract",
  { id: "receptionSlot", breakpoint: "mantine-visible-from-lg" },
  { id: "salesItem", breakpoint: "mantine-visible-from-xl" },
  "product",
  "company",
  { id: "amount", breakpoint: "mantine-visible-from-sm" },
  { id: "remainingAmount", breakpoint: "mantine-visible-from-lg" },
  { id: "finalAmount", breakpoint: "mantine-visible-from-xl" },
  "status",
  { id: "lastPrice", breakpoint: "mantine-visible-from-lg" },
  { id: "fullLoad", breakpoint: "mantine-visible-from-lg" },
  // { id: "orderCurrency", breakpoint: "mantine-visible-from-lg" },
  // Replace <CURRENCY> with the runtime currency (e.g. `totalPriceWithFee.EUR`)
  "actions",
];

/** The columns that stay visible on a collapsed mobile row: the id cell, the date and the counterparty. */
export const DEFAULT_ORDER_MOBILE_HEADER_COLUMNS = ["tradeId", "created", "company"];
